import usdFormatter from './usdFormatter';

/**
 * Format billing plan payment
 *
 * @param {object} plan Billing plan.
 * @param {number} sites Number of sites.
 *
 * @returns {string} Formatted plan payment details
 */
export const billingPlanFilter = (plan, sites) => {
    const multiplier = sites || 1;

    if ('month' === plan.interval) {
        const totalCost = plan.amount * multiplier;
        const formattedAmount = usdFormatter(totalCost);

        return `${formattedAmount}`;
    } else {
        const monthlyCost = plan.amount / 12;
        const totalCost = monthlyCost * multiplier;
        const formattedAmount = usdFormatter(totalCost);

        return `${formattedAmount}`;
    }
};
